module.exports = __webpack_public_path__ + "assets/6b83be15947354fe28ae3136fff74100.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_6.mp3
 ** module id = 365
 ** module chunks = 0
 **/